export const UPDATE_RECS_LOADED = 'UPDATE_RECS_LOADED';
export const UPDATE_REPEAT_ITEMS = 'UPDATE_REPEAT_ITEMS';
export const UPDATE_BEST_SELLER_ITEMS = 'UPDATE_BEST_SELLER_ITEMS';
export const UPDATE_COMPLETE_MEAL_ITEMS = 'UPDATE_COMPLETE_MEAL_ITEMS';
export const UPDATE_FREQUENTLY_ADD_WITH_ITEM = 'UPDATE_FREQUENTLY_ADD_WITH_ITEM';
export const RESET_RECOMMENDATIONS = 'RESET_RECOMMENDATIONS';
